import { theme } from './theme';

export const BUTTON_STYLE = {
  primary: {
    backgroundColor: theme.bg.primary,
    color: theme.color.secondary,
    hoverColor: theme.bg.lightTeal,
    hoverBgColor: theme.bg.secondary,
  },
  secondary: {
    backgroundColor: theme.bg.darkGray,
    color: theme.color.secondary,
    hoverColor: theme.bg.secondary,
    hoverBgColor: theme.bg.darkerGray,
  },
  tertiary: {
    backgroundColor: '#f6ad55',
    color: '#1a202c',
    hoverColor: '#ed8936',
    hoverBgColor: theme.bg.secondary,
  },
  text: {
    backgroundColor: 'transparent',
    color: theme.color.primary,
    hoverColor: theme.color.primary,
    hoverBgColor: 'transparent',
    border: 0
  }
};
